<div class="event-card" [class]="getStatusClass()">
  <div class="event-card-header">
    <div class="event-status">
      <span class="status-badge">{{ getStatusText() | transloco }}</span>
    </div>

    @if (showActions()) {
      <div class="event-actions" (click)="$event.stopPropagation()">
        <button class="action-btn edit-btn" (click)="onEdit($event)" title="{{ 'edit' | transloco }}">
          <q-svg-wrapper iconPath="project-icons/pencil" width="20" height="20" viewBox="0 0 24 24"></q-svg-wrapper>
        </button>
        <button class="action-btn delete-btn" (click)="onDelete($event)" title="{{ 'delete' | transloco }}">
          <q-svg-wrapper iconPath="project-icons/trash" width="20" height="20" viewBox="0 0 24 24"></q-svg-wrapper>
        </button>
      </div>
    }
  </div>

  <div class="event-card-body">
    <h3 class="event-title semibold-18">{{ event().name }}</h3>

    @if (event().description) {
      <p class="event-description regular-14">{{ event().description }}</p>
    }

    <div class="event-meta">
      <div class="meta-item">
        <span class="meta-label">{{ 'content' | transloco }}:</span>
        <span class="meta-value">
          @if (event().quests && event().quests.length > 0) {
            {{ event().quests.length }} {{ getContentDescription() | transloco }}
          } @else if (event().obelisks && event().obelisks.length > 0) {
            {{ event().obelisks.length }} {{ getContentDescription() | transloco }}
          } @else if (event().compilations && event().compilations.length > 0) {
            {{ event().compilations.length }} {{ getContentDescription() | transloco }}
          } @else {
            {{ getContentDescription() | transloco }}
          }
        </span>
      </div>

      <div class="meta-item">
        <span class="meta-label">{{ 'participants' | transloco }}:</span>
        <span class="meta-value">{{ event().slots || 0 }}</span>
      </div>

      @if (event().endDate) {
        <div class="meta-item">
          <span class="meta-label">{{ 'ends' | transloco }}:</span>
          <span class="meta-value">{{ formatEventDate(event().endDate) }}</span>
        </div>
      }
    </div>

    <div class="event-tags">
      <span class="tag visibility-tag">{{ event().visibility | transloco }}</span>
      <span class="tag access-tag">{{ event().access | transloco }}</span>
    </div>
  </div>
</div>


